<div
  class="shop-card mb-3 rounded-lg bg-primary-lightest p-3"
  *ngFor="let rv of reviews; let rvi = index">
  <div class="sc-header mb-5">
    <div class="content flex justify-center gap-3">
      <div class="shop flex flex-1 items-center gap-3">
        <div class="shop-img-wrapper">
          <div
            class="c-img-r aspect-square w-10 overflow-hidden rounded-full object-cover">
            <img
              [src]="rv.logo_path ? rv.logo_path : shopDefaultImg"
              (error)="handleShopImgError()" />
          </div>
        </div>
        <div class="shop-info flex-1">
          <div class="shop-name font-bold">{{ rv.shop_name }}</div>
          <div class="date block lg:hidden">{{ rv.formatted_order_date }}</div>
        </div>
      </div>
      <div class="date hidden lg:block">
        <div class="label text-sm text-primary-darkest/50">Order Date</div>
        <div class="date">{{ rv.formatted_order_date || '-' }}</div>
      </div>
    </div>
  </div>
  <div class="sc-body">
    <div class="review-list flex flex-col gap-y-5">
      <div
        class="review-item"
        *ngFor="let product of rv.pending_reviews; let pri = index">
        <div class="product gap-x-5 lg:flex">
          <div class="product-img-wrapper mx-auto mb-5 w-32">
            <img
              [src]="
                product.product_default_image_path &&
                product.product_default_image_path[0] &&
                product.product_default_image_path[0].small
                  ? product.product_default_image_path[0].small.path
                  : productDefaultImg
              "
              alt=""
              class="product-img"
              (error)="handleProductImgError()" />
          </div>
          <div class="product-info flex-1">
            <div class="brand font-semibold text-amber-600">
              {{ product.product_brand.name }}
            </div>
            <div class="name text-max font-semibold text-primary-darkest">
              {{ product.product_name }}
            </div>
            <div class="variant" *ngIf="product.product_variant_name">
              Varian: {{ product.product_variant_name }}
            </div>
            <div class="add-review" *ngIf="formHandler.toggle[rvi][pri]">
              <div
                class="rating-wrapper mb-7"
                [ngClass]="{
                  'is-invalid': formHandler.error[rvi][pri].emptyRate
                }">
                <div
                  class="label text-gray-500"
                  *ngIf="!formHandler.error[rvi][pri].emptyRate">
                  Beri rating pada produk ini
                </div>
                <div
                  class="label"
                  *ngIf="formHandler.error[rvi][pri].emptyRate">
                  *Rating produk harus diisi
                </div>
                <!-- desktop -->
                <div
                  class="star hidden lg:block"
                  [ngClass]="
                    formHandler.form[rvi][pri].rate &&
                    formHandler.changeRating[rvi][pri] == false
                      ? 'rated'
                      : 'rating'
                  "
                  (mouseenter)="formHandler.changeRating[rvi][pri] = true"
                  (mouseleave)="formHandler.changeRating[rvi][pri] = false">
                  <a
                    *ngFor="let rate of [1, 2, 3, 4, 5]"
                    (click)="giveRating(rate, rvi, pri)"
                    [ngClass]="{
                      'text-yellow-500':
                        rate <= formHandler.form[rvi][pri].rate,
                      'text-gray-400': rate >= formHandler.form[rvi][pri].rate
                    }">
                    <fa-icon [icon]="faStar" class="icon"></fa-icon>
                  </a>
                </div>
                <!-- mobile -->
                <div class="star rated block lg:hidden">
                  <a
                    *ngFor="let rate of [1, 2, 3, 4, 5]"
                    (click)="giveRating(rate, rvi, pri)"
                    [ngClass]="{
                      'text-yellow-500':
                        rate <= formHandler.form[rvi][pri].rate,
                      'text-gray-400': rate <= formHandler.form[rvi][pri].rate
                    }">
                    <fa-icon [icon]="faStar" class="icon"></fa-icon>
                  </a>
                </div>
              </div>
              <label for="review" class="control-label text-primary-darkest"
                >Review</label
              >
              <div
                class="p-input-wrapper"
                [ngClass]="{
                  'is-invalid': formHandler.error[rvi][pri].emptyReview
                }">
                <textarea
                  id="review"
                  rows="5"
                  class="p-form-control w-full rounded-lg border-2 border-primary-dark bg-primary-lightest p-2 outline-none"
                  placeholder="Tuliskan ulasan Anda mengenai produk ini"
                  #reviewInput
                  (keyup)="inputReview(rvi, pri, reviewInput)"
                  >{{ formHandler.form[rvi][pri].review }}</textarea
                >
              </div>
              <div class="review-images-wrapper py-3">
                <!-- Desktop Upload Image -->
                <!-- <div (click)="openReviewsImage()" class="label hidden lg:block">
                  <fa-icon
                    class="cursor-pointer text-5xl text-gray-400 hover:text-primary-md-dark"
                    [icon]="faImg"></fa-icon>
                </div> -->
                <!-- Mobile Upload Image -->
                <!-- <div (click)="openReviewsImage()" class="label lg:hidden">
                  <button class="rounded-lg bg-gray-400 p-2 text-white">
                    Upload Image
                  </button>
                </div> -->
                <swiper
                  class="review-images swiper-container py-3 text-primary-md-dark"
                  [slidesPerView]="'auto'"
                  [spaceBetween]="15">
                  <ng-template
                    swiperSlide
                    class="swiper-slide relative w-fit"
                    *ngFor="let num of [1, 2, 3, 4]">
                    <input
                      #riimage
                      type="file"
                      accept="image/*"
                      class="hidden"
                      (change)="onAddReviewImage($event, rvi, pri, num)" />
                    <button
                      class="btn-add-image flex aspect-square w-16 items-center justify-center rounded-md border border-primary-md-dark p-3"
                      (click)="riimage.click()"
                      *ngIf="!getReviewImage(rvi, pri, num)">
                      <fa-icon [icon]="faPlus"></fa-icon>
                    </button>
                    <img
                      class="review-img aspect-square w-16 rounded-md border border-primary-md-dark object-contain"
                      (click)="riimage.click()"
                      *ngIf="getReviewImage(rvi, pri, num)"
                      [src]="
                        getReviewImage(rvi, pri, num)
                          ? getReviewImage(rvi, pri, num)
                          : productDefaultImg
                      " />
                    <a
                      class="delete-img absolute -top-2 -right-2 z-10 cursor-pointer rounded-md text-primary-md-dark"
                      *ngIf="getReviewImage(rvi, pri, num)"
                      (click)="deleteReviewImage(rvi, pri, num)">
                      <fa-icon [icon]="faTimesCircle"></fa-icon>
                    </a>
                  </ng-template>
                </swiper>
              </div>

              <div class="c-btn-group-rtl">
                <button
                  class="mt-5 w-full rounded-md bg-primary-md-dark px-3 py-2 text-center text-sm text-white transition duration-500 hover:-translate-y-1 lg:w-fit"
                  (click)="submitReview(rvi, pri)"
                  [disabled]="formHandler.loading[rvi][pri]"
                  [ngClass]="{ loading: formHandler.loading[rvi][pri] }">
                  <span class="btn-label">Send Review</span>
                  <fa-icon
                    *ngIf="formHandler.loading[rvi][pri]"
                    class="load-icon"
                    [icon]="faSpinner"
                    [spin]="true"></fa-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="btn-add c-btn-group-rtl mt-5 lg:mt-0">
            <button
              class="rounded-lg border-2 border-primary-md-dark bg-primary-lightest p-2 text-primary-md-dark"
              (click)="toggleAddReview(rvi, pri)">
              Add Review
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="load-more flex justify-center" *ngIf="!hideLoadMore">
  <button
    type="button"
    class="px-3 py-2 text-primary-darkest hover:rounded-lg hover:bg-primary-light"
    (click)="loadReview()"
    [disabled]="loadMoreLoading">
    <span class="btn-label"
      >Show more <fa-icon class="ml-1" [icon]="faChevronDown"></fa-icon
    ></span>
  </button>
</div>
<div *ngIf="loadMoreLoading" class="flex justify-center">
  <fa-icon
    class="load-icon text-primary-darkest"
    [icon]="faSpinner"
    [spin]="true"></fa-icon>
</div>
